module.exports = __webpack_public_path__ + "img/weather09.b71f681c.png";